import React, { useRef, useState, useEffect } from "react";
import "../styles/Carrusel.css";

import txt_consulta from "../assets/images/publi/txt-consulta.png";
import img_consulta from "../assets/images/publi/img-consulta.png";

import txt_esterilizacion from "../assets/images/publi/txt-esterilizacion.png";
import img_esterilizacion from "../assets/images/publi/img-esterilizacion.png";

import txt_vacuna from "../assets/images/publi/txt-vacuna.png";
import img_vacuna from "../assets/images/publi/img-vacuna.png";

function Carrusel() {
  const viewport = useRef();
  const slider = useRef();
  const indice = useRef(0);
  const total_publiImg = 3;
  const [ancho, setAncho] = useState(0);
  const intervalo_publi = 2500;

  const timer = useRef();

  useEffect(() => {
    const actualizarAncho = () => {
      if (viewport.current) {
        setAncho(viewport.current.offsetWidth);
      }
    };

    actualizarAncho();

    window.addEventListener("resize", actualizarAncho);

    return () => window.removeEventListener("resize", actualizarAncho);
  }, []);

  useEffect(() => {
    if (ancho === 0) return;
    if (!slider.current) return;

    timer.current = setInterval(() => {
      indice.current =
        indice.current === total_publiImg - 1 ? 0 : indice.current + 1;
      slider.current.style.transform = `translateX(-${
        indice.current * ancho
      }px)`;
    }, intervalo_publi);
    return () => {
      clearInterval(timer.current);
      timer.current = null;
    };
  }, [ancho]);

  function mover_slider(mover) {
    if (mover === 1) {
      indice.current =
        indice.current === total_publiImg - 1 ? 0 : indice.current + 1;
    } else {
      indice.current =
        indice.current === 0 ? total_publiImg - 1 : indice.current - 1;
    }

    slider.current.style.transform = `translateX(-${indice.current * ancho}px)`;
  }

  return (
    <div className="carrusel">
      <div
        className="btn-carrusel"
        onClick={() => {
          mover_slider(-1);
        }}
      ></div>
      <div className="content-carrusel" ref={viewport}>
        <div className="slider" ref={slider}>
          <div className="publicidad">
            <img src={txt_consulta} className="content-publi"></img>
            <img src={img_consulta} className="content-publi"></img>
          </div>
          <div className="publicidad">
            <img src={txt_esterilizacion} className="content-publi"></img>
            <img src={img_esterilizacion} className="content-publi"></img>
          </div>
          <div className="publicidad">
            <img src={txt_vacuna} className="content-publi"></img>
            <img src={img_vacuna} className="content-publi"></img>
          </div>
        </div>
      </div>
      <div
        className="btn-carrusel"
        onClick={() => {
          mover_slider(1);
        }}
      ></div>
    </div>
  );
}

export default Carrusel;
